import React from "react";
import "../../css/Homepage/Homemid.css";
import chat from "../../images/homemid/Chat.png";
import coin from "../../images/homemid/Coin.png";
import walletinapp from "../../images/homemid/walletinapp.png";

function Homemid() {
  return (
    <div className="homemid-container">
      <div className="homemid-wrap">
        <div className="homemid-special-color-flex">
          <p className="homemid-p">—— Key Features</p>
          <h1>
            <span className="homemid-span2">1 million+ </span>
            <span className="homemid-span">Members Across the </span>
          </h1>
          <h1>
            <span className="homemid-span">World and Growing</span>
          </h1>
        </div>

        <div className="homemid-boxcontainer">
          <div className="homemid-box1">
            <img src={chat} className="homemid-icon1" />
            <p className="homemid-pa">
              Experience the power of communication our versatile real-time
              chat. Enjoy a wide range of features, including voice and video
              calls, file transfers, and Red Packet sharing. Our group chat
              supports up to 6,000 members, ensuring your conversations remain
              inclusive and engaging.{" "}
            </p>
          </div>
          <div className="homemid-box2">
            <img src={coin} className="homemid-icon1" />

            <p className="homemid-pa2">
              Get the opportunity to earn tokens as you engage with others,
              share your knowledge, and support the growth of the platform.
              Watch your digital assets grow as you deepen your connections
              within our thriving network.
            </p>
          </div>
          <div className="homemid-box3">
            <img src={walletinapp} className="homemid-icon1" />
            <p className="homemid-pa">
              Our in-app wallet connects seamlessly with your existing
              decentralized wallets, allowing you to manage your digital assets
              with ease. Enjoy the freedom to access your funds, make
              transactions, and monitor your portfolio, all within our secure
              and user-friendly platform.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Homemid;
